import { GetApiCall } from "./axiosSetup";

export const GET_USER_INFO = '/user/get-user-info';

export const GetUserInfo = async () => GetApiCall(GET_USER_INFO);